import React from 'react';
import Blog from '../Blog/Blog';
import blogimg1 from '../../images/java.jpeg'
import blogimg2 from '../../images/html.jpg'
import blogimg3 from '../../images/react.png'
import './Blogs.css'
// import link3 from 'https://drive.google.com/file/d/1GgdcqUI75U0Hi3FrzUITQi7SUf1LxNxL/view?usp=sharing'
import Footer from '../Footer/Footer';
const Blogs = () => {
    const allblogs = [
        {
            id:1,
            name:'HTML AND CSS',
            describtion:'In this blogs i will discuss Top 10 Things Every Web-Developer Must Knwo about About JS.',
            img:blogimg1,
            Link:'https://drive.google.com/file/d/1EfddQl6uIn9MWlwb7DpWE575c9VJ8pE1/view?usp=sharing'
            
        },
        {
            id:2,
            name:'React.js',
            describtion:'if you want to be a Professional React developer you must know Advance react.js Features.',
            img:blogimg2,
            Link:'https://drive.google.com/file/d/1ne0bRmTyQUMwTF2rSKllloBX3sgchTr6/view?usp=sharing'
            
        },
        {
            id:3,
            name:'javaScript Es6',
            describtion:'New Es6 Features will help you to write your code more efficiently.Ecma Script(6) is .....',
            img:blogimg3,
            link:'https://drive.google.com/file/d/1GgdcqUI75U0Hi3FrzUITQi7SUf1LxNxL/view'
            
        },
        
       
        
    ]
    return (
        <div className='row main-blog'>
            <h2>My Blogs</h2>
            <div className='product-container' data-aos="fade-up"
     data-aos-duration="3000">
                {
                    allblogs.map(alblog => <Blog
                    
                        key={alblog.id}
                        alblog={alblog}
                    ></Blog>)
                }
            </div>
            <Footer></Footer>
        </div>
    );
};

export default Blogs;